import React from "react";

const StartTime = ({ startDate }) => {
  const getStartTime = (date) => {
    const d = new Date(date);
    return d.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div>
      <p>
        <span style={{color:"#96144d",fontWeight:"600",fontSize:"15px"}}>Start Time:</span> <span style={{fontSize:"16px",fontWeight:"600"}}>{getStartTime(startDate)}</span>
      </p>
    </div>
  );
};

export default StartTime;
